import type { SegmentedProps } from 'antd';
import { Segmented } from 'antd';

function DashboardSegmented({ className, ...props }: SegmentedProps<string>) {
  return <Segmented<string> size='middle' block className={[className].filter(Boolean).join(' ')} {...props} />;
}

export default DashboardSegmented;
